define("shared/components/shared/upgrade/mobile-plan-card", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Ui::Button
    @additional="block"
    @onClick={{fn @selectPlan @plan.planType}}
    @size="large"
    @text={{t "authorization.sign_up_trial.button_yes"}}
    @variant="outline"
    class="o--card tPF--plan__card tPF--plan__item--{{@plan.planType}} {{this.selectionClass}}"
  >
    <div class="tPF--plan__cardSectionTitle">
      <h2 class="tPF--plan__title">{{t (concat "plans.plan_names." @plan.planType)}}</h2>
      <div class="tPF--plan__price tPF--plan__note">
        <span class="u--m__r__xs u--text--lg">
          <b>
            {{t "plans.currency_symbol"}}
            {{div @plan.monthlyPrice 100}}
          </b>{{t "plans.auto_trial.end_trial.per_month"}}
        </span>
        {{svg-jar this.verifiedIconSvg class="o--icon o--icon--lg tPF--plan__priceIcon"}}
      </div>
    </div>
    <div class="u--m__b__md">
      <p class="u--text--md">{{t (concat "authorization.sign_up_trial." @plan.planType ".description")}}</p>
      <ul class="u--m__0 u--p__0 tPF--plan__cardList">
        {{#each @plan.trialOptInHighlights.mobile.includes as |highlight|}}
          <li class="tPF--plan__cardListBullet u--text--base u--text--bold">
            {{highlight}}
          </li>
        {{/each}}
      </ul>
    </div>
  
    {{#if (and @showBonusFeatures this.hasBonusFeatures)}}
      <Shared::Upgrade::BonusFeatures />
    {{/if}}
  
    <div class="tPF--plan__meta">
      <Shared::Ui::Button
        @onClick={{this.openShowAllFeaturesModal}}
        @variant="unstyled"
        class="tPF--plan__link u--p__0 u--text--uppercase u--text--md"
        {{track "expanded-trial-offer" "click" plan=@plan.planType}}
      >
        {{svg-jar "info" class="o--icon tPF--plan__icon"}}
        {{t "authorization.sign_up_trial.plan_details_link" planName=@plan.name}}
      </Shared::Ui::Button>
    </div>
  </Shared::Ui::Button>
  
  {{#if this.showAllFeaturesModal}}
    <Shared::Upgrade::AllFeaturesModal
      @close={{toggle-action "showAllFeaturesModal" this}}
      @isMonthly={{this.currentSubscriptionPlan.isMonthly}}
      @plan={{@plan}}
    />
  {{/if}}
  */
  {
    "id": "97h3YqG2",
    "block": "[[[8,[39,0],[[16,0,[29,[\"o--card tPF--plan__card tPF--plan__item--\",[30,1,[\"planType\"]],\" \",[30,0,[\"selectionClass\"]]]]]],[[\"@additional\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",[28,[37,1],[[30,2],[30,1,[\"planType\"]]],null],\"large\",[28,[37,2],[\"authorization.sign_up_trial.button_yes\"],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,0],[14,0,\"tPF--plan__cardSectionTitle\"],[12],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"tPF--plan__title\"],[12],[1,[28,[35,2],[[28,[37,3],[\"plans.plan_names.\",[30,1,[\"planType\"]]],null]],null]],[13],[1,\"\\n    \"],[10,0],[14,0,\"tPF--plan__price tPF--plan__note\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--m__r__xs u--text--lg\"],[12],[1,\"\\n        \"],[10,\"b\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"plans.currency_symbol\"],null]],[1,\"\\n          \"],[1,[28,[35,4],[[30,1,[\"monthlyPrice\"]],100],null]],[1,\"\\n        \"],[13],[1,[28,[35,2],[\"plans.auto_trial.end_trial.per_month\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[1,[28,[35,5],[[30,0,[\"verifiedIconSvg\"]]],[[\"class\"],[\"o--icon o--icon--lg tPF--plan__priceIcon\"]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--m__b__md\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md\"],[12],[1,[28,[35,2],[[28,[37,3],[\"authorization.sign_up_trial.\",[30,1,[\"planType\"]],\".description\"],null]],null]],[13],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"u--m__0 u--p__0 tPF--plan__cardList\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,1,[\"trialOptInHighlights\",\"mobile\",\"includes\"]]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[14,0,\"tPF--plan__cardListBullet u--text--base u--text--bold\"],[12],[1,\"\\n          \"],[1,[30,3]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[3]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[28,[37,9],[[30,4],[30,0,[\"hasBonusFeatures\"]]],null],[[[1,\"    \"],[8,[39,10],null,null,null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[14,0,\"tPF--plan__meta\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,0,\"tPF--plan__link u--p__0 u--text--uppercase u--text--md\"],[4,[38,11],[\"expanded-trial-offer\",\"click\"],[[\"plan\"],[[30,1,[\"planType\"]]]]]],[[\"@onClick\",\"@variant\"],[[30,0,[\"openShowAllFeaturesModal\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"info\"],[[\"class\"],[\"o--icon tPF--plan__icon\"]]]],[1,\"\\n      \"],[1,[28,[35,2],[\"authorization.sign_up_trial.plan_details_link\"],[[\"planName\"],[[30,1,[\"name\"]]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"  \"],[8,[39,12],null,[[\"@close\",\"@isMonthly\",\"@plan\"],[[28,[37,13],[\"showAllFeaturesModal\",[30,0]],null],[30,0,[\"currentSubscriptionPlan\",\"isMonthly\"]],[30,1]]],null],[1,\"\\n\"]],[]],null]],[\"@plan\",\"@selectPlan\",\"highlight\",\"@showBonusFeatures\"],false,[\"shared/ui/button\",\"fn\",\"t\",\"concat\",\"div\",\"svg-jar\",\"each\",\"-track-array\",\"if\",\"and\",\"shared/upgrade/bonus-features\",\"track\",\"shared/upgrade/all-features-modal\",\"toggle-action\"]]",
    "moduleName": "shared/components/shared/upgrade/mobile-plan-card.hbs",
    "isStrictMode": false
  });
  let MobilePlanCardComponent = _exports.default = (_class = class MobilePlanCardComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "plans", _descriptor, this);
      _initializerDefineProperty(this, "showAllFeaturesModal", _descriptor2, this);
    }
    get selectionClass() {
      if (!this.args.selectedPlan) {
        return '';
      }
      return this.args.selectedPlan === this.args.plan.planType ? 'is--selected' : 'is--unselected';
    }
    get hasBonusFeatures() {
      return this.plans.mobileTrialOptInPlanNames.includes(this.args.plan.planType);
    }
    get verifiedIconSvg() {
      return this.args.selectedPlan === this.args.plan.planType ? 'verified-solid' : 'verified';
    }
    openShowAllFeaturesModal(event) {
      event.stopPropagation();
      this.showAllFeaturesModal = true;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showAllFeaturesModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "openShowAllFeaturesModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openShowAllFeaturesModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MobilePlanCardComponent);
});